module.exports = __webpack_public_path__ + "static/img/bdm_rank3.01ae89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/bdm_rank3.png
// module id = 4Yoe
// module chunks = 0